import React from 'react'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'

import config from 'config'
import { Participant as ParticipantPage } from 'containers/pages/register'
import * as Participant from 'containers/forms/participant'

const urlPrefix = `${config.publicPath}/register/participant`

export default [

  {
    path: `${urlPrefix}`,
    component: props => (
      <ParticipantPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/participant/welcome`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/welcome`,
        exact: true,
        component: props => (
          <Participant.Welcome {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/welcome/:ecode`,
        exact: true,
        component: props => (
          <Participant.Welcome {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/language`,
        exact: true,
        component: props => (
          <Participant.Language {...props} />
        ),
        activeId: 2,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/level`,
        exact: true,
        component: props => (
          <Participant.Level {...props} />
        ),
        activeId: 3,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/contacts`,
        exact: true,
        component: props => (
          <Participant.Contacts {...props} />
        ),
        activeId: 4,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/details`,
        exact: true,
        component: props => (
          <Participant.Details {...props} />
        ),
        activeId: 5,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/parent`,
        exact: true,
        component: props => (
          <Participant.Parent {...props} />
        ),
        activeId: 6,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/profile`,
        exact: true,
        component: props => (
          <Participant.Profile {...props} />
        ),
        activeId: 7,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/payment`,
        exact: true,
        component: props => (
          <Participant.ChoosePayment {...props} />
        ),
        activeId: 8,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/account`,
        exact: true,
        component: props => (
          <Participant.Account {...props} />
        ),
        activeId: 9,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <Participant.Success {...props} />
        ),
        activeId: 10,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
